import { Typography, withStyles } from "@material-ui/core";
import React from "react";
import GoalPlanFormContainer from "../shared/goalPlanForm/goalPlanFormContainer";
import { t, Trans } from "adapters/i18n";

const GoalPlanReviewPage = ({
  goalPlanId,
  onBack,
  onSubmit,
  enableLoading,
  disableLoading,
  notifyError,
  classes,
}) => {
  const TEXT_BUTTON_SUBMIT = t("common:actions.save-revision").toUpperCase();
  const subtitle = () => (
    <Typography className={classes.subtitle}>
      <Trans i18nKey="goalPlan:create-new-plan-revision-info" components={{ b: <b /> }} />
    </Typography>
  );

  return (
    <GoalPlanFormContainer
      titlePage={t("goalPlan:create-new-plan-revision")}
      titleContent=""
      subtitleContent={subtitle}
      onBack={onBack}
      onSubmit={onSubmit}
      enableLoading={enableLoading}
      disableLoading={disableLoading}
      notifyError={notifyError}
      initialDataPlanId={goalPlanId}
      disableEditPlanInfo
      textButtonSubmit={TEXT_BUTTON_SUBMIT}
    />
  );
};

const styles = () => {
  return {
    subtitle: {
      fontSize: "16px",
      color: "#444444",
      paddingTop: "20px",
    },
  };
};

export default withStyles(styles)(GoalPlanReviewPage);
